import React from "react";
import '../../entrydoor.css';
//import "./DoorSearch.css"; // Add CSS for styling alignment

const DoorSearch = ({ placeholder = "Search doors...", onChange }) => { // ADDED onChange prop
    return (
        <div className="door-search-container">
            <input
                type="text"
                className="door-search-input"
                placeholder={placeholder}
                onChange={(event) => onChange(event.target.value)} // Notify parent when input changes
            />
        </div>
    );
};

export default DoorSearch;
